import { useGlobalInterceptors } from "@/core/api/common";
import { WEBSOCKETS_ENDPOINT_URL } from "@/core/api/graphql/consts";

export const apolloFetch = (() => {
  const { onRequest, onResponse } = useGlobalInterceptors();

  return async (input: string | Request | URL, init?: RequestInit) => {
    // Ensure init object exists so interceptors can add headers
    const requestInit: RequestInit = init ?? {};
    await Promise.all(onRequest.value.map((intercept) => intercept(input, requestInit)));
    const response = await fetch(input, requestInit);
    await Promise.all(onResponse.value.map((intercept) => intercept(response)));
    return response;
  };
})();

export const apolloWebSocketConnectionParams = (() => {
  const { onRequest } = useGlobalInterceptors();

  return async () => {
    const init: RequestInit = {};
    await Promise.all(onRequest.value.map((intercept) => intercept(WEBSOCKETS_ENDPOINT_URL, init)));
    // Return headers directly for WebSocket connection, not wrapped in { headers: {...} }
    return (init.headers as Record<string, string>) || {};
  };
})();
